/* eslint-disable new-cap, no-console */
function arrayHasData(arr) {
	return arr && arr.length && arr.length > 0;
}

export default class RrAdapter {
	constructor(rrConfig) {
		this.rrConfig = rrConfig;

		if (typeof window.rrInitialPageLoad === 'undefined') {
			window.rrInitialPageLoad = true;
		}
		this.initalPageLoad = window.rrInitialPageLoad;
		this.placementData = {};

		window.rrOdCallback = data => {
			const placementMap = {};

			data.placements.forEach(placement => {
				const name = placement.placementType.split('.')[1];
				placementMap[name] = placement.placementType;
			});

			this.placementData = placementMap;
		};

		window.RR.jsonCallback = function () {
			const cookieName = 'rr_rcs';
			const cookieDuration = window.RR.rcsCookieDefaultDuration;
			const cookieData = window.rr_remote_data;

			function setCookie(cName, cValue, expDays) {
				const date = new Date();
				date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
				const dateStr = date.toUTCString();
				const expires = `expires=${dateStr}`;
				const encodedName = encodeURIComponent(cName);
				const encodedValue = encodeURIComponent(cValue);
				document.cookie = `${encodedName}=${encodedValue};${expires};path=/;Secure`;
			}

			setCookie(cookieName, cookieData, cookieDuration);

			if (
				typeof window.renderRecommendations === 'function' &&
				window.RR.data &&
				window.RR.data.JSON &&
				window.RR.data.JSON.length !== 0
			) {
				try {
					window.renderRecommendations(window.RR.data.JSON);
				} catch (err) {
					console.error(err); // eslint-disable-line no-console
				}
			}
		};

		window.renderRecommendations = rrJsonData => {
			const joinedData = this.joinDataFeeds(rrJsonData);
			this.resolve(joinedData);
		};

		this.resolve = () => {};
		this.reject = () => {};
	}

	run() {
		return new Promise((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;

			this.init();

			window.rr_flush_onload();
			window.r3();
		});
	}

	joinDataFeeds(skuData) {
		return skuData.placements.map(placement => {
			const productData = {};
			placement.skus.forEach(skuObj => {
				productData[skuObj.id] = skuObj.url;
			});

			const joinedData = Object.assign({}, placement, {
				zoneId: this.placementData[placement.name],
				title: placement.heading,
				products: productData,
			});
			return joinedData;
		});
	}

	init() {
		if (!this.rrConfig || typeof window.r3_common !== 'function') {
			this.reject(
				'RichRelevance is not enabled or there was a problem loading the required modules',
			);
			return;
		}

		if (!window.R3_COMMON || !this.r3Common) {
			this.r3Common = new window.r3_common();
			window.R3_COMMON = this.r3Common;
			this.loadCommonSettings(this.rrConfig);
			this.checkCookieConsent();
		}

		if (this.rrConfig.debugMode) {
			this.r3Common.forceDebugMode(this.rrConfig.debugMode);
		}

		this.addPlacements(this.rrConfig.placements);

		if (arrayHasData(this.rrConfig.refinements)) {
			this.parseCategoryRefinements(this.rrConfig.refinements);
		}
		if (this.rrConfig.pageType === 'HOME') {
			this.parseHomeOptions();
		}

		if (this.rrConfig.pageType === 'SEARCH') {
			this.parseSearchOptions(this.rrConfig.search, this.initalPageLoad);
		} else if (this.rrConfig.pageType === 'CATEGORY') {
			this.parseCategoryOptions(this.rrConfig.category, this.initalPageLoad);
		} else if (this.rrConfig.pageType === 'CAMPAIGN') {
			this.parseCampaignOptions(this.rrConfig.campaignCategory);
		} else if (this.rrConfig.pageType === 'PDP') {
			this.parseProductOptions(this.rrConfig.product, this.initalPageLoad);
		} else if (this.rrConfig.pageType === 'CART') {
			this.parseBasketOptions(this.rrConfig.basket, this.initalPageLoad);
		} else if (this.rrConfig.pageType === 'ORDERCONFIRMATION') {
			this.parseOrderOptions(this.rrConfig.purchased, this.initalPageLoad);
		} else if (this.rrConfig.pageType === 'ORDERHISTORY') {
			this.parsePersonalOptions();
		}
		window.rrInitialPageLoad = false;
	}

	loadCommonSettings(config) {
		this.r3Common.setApiKey(config.apiKey);
		this.r3Common.setBaseUrl(config.baseUrl);
		this.r3Common.setClickthruServer(
			`${window.location.protocol}//${window.location.host}`,
		);
		this.r3Common.setSessionId(config.sessionId);
		this.r3Common.setUserId(config.userId);
		this.r3Common.setRegionId(config.regionId);
		this.r3Common.jsonCallback = 'rrOdCallback';

		// Debug Mode
		if (config.debugMode) {
			this.r3Common.forceDevMode();
		}
	}

	checkCookieConsent() {
		if (
			window.OnetrustActiveGroups &&
			window.OnetrustActiveGroups.indexOf('C0003') === -1 // This is the current 'Functional' cookie category ID with OneTrust
		) {
			try {
				window.R3_COMMON.setNoCookieMode(true);
				window.R3_COMMON.setPrivateMode(true);
			} catch (err) {
				if (console) console.error(err); // eslint-disable-line no-console
			}
		}
	}

	addPlacements(placements) {
		if (arrayHasData(placements)) {
			$(placements).each((key, placementType) => {
				window.R3_COMMON.addPlacementType(placementType);
			});
		}
	}

	parseCategoryRefinements(refinmentOptions) {
		// add breadcrumb data to help refine the search
		refinmentOptions.forEach(refinement => {
			this.r3Common.addRefinement(refinement.code, refinement.valueCode);
		});
	}

	parseHomeOptions() {
		const r3Home = new window.r3_home();
		window.R3_HOME = r3Home;
	}

	parseSearchOptions(searchConfig, pageLoad) {
		if (pageLoad) {
			const r3Search = new window.r3_search();
			r3Search.setTerms(searchConfig.terms);
			searchConfig.items.forEach(itemId => {
				r3Search.addItemId(itemId);
			});
			window.R3_SEARCH = r3Search;
		} else {
			searchConfig.items = [];
		}
	}

	parseCategoryOptions(categoryConfig, pageLoad) {
		if (pageLoad) {
			const r3Category = new window.r3_category();
			r3Category.setId(categoryConfig.id);
			r3Category.setName(categoryConfig.name);
			categoryConfig.items.forEach(itemId => {
				r3Category.addItemId(itemId);
			});
			window.R3_CATEGORY = r3Category;
		} else {
			categoryConfig.items = [];
		}
	}

	parseCampaignOptions(campaignConfig) {
		const r3Campaign = new window.r3_category();

		if (window.RR_OD_CONFIG) {
			r3Campaign.setId(window.RR_OD_CONFIG?.fallbackCategoryId);
		}
		r3Campaign.setName(campaignConfig.campaign);
		window.R3_CATEGORY = r3Campaign;
	}

	parseProductOptions(productOptions, pageLoad) {
		const r3Item = new window.r3_item();
		if (pageLoad) {
			r3Item.setId(productOptions.sku);
			this.r3Common.addCategoryHintId(productOptions.category.code);
		}

		r3Item.setRecommendable(productOptions.stockLevel > 0);
		window.R3_ITEM = r3Item;
	}

	parseBasketOptions(basketItems, pageLoad) {
		if (pageLoad) {
			const r3Cart = new window.r3_cart();
			basketItems.forEach(itemId => {
				r3Cart.addItemId(itemId);
			});
			window.R3_CART = r3Cart;
		}
	}

	parseOrderOptions(orderOptions, pageLoad) {
		if (pageLoad) {
			const r3Purchased = new window.r3_purchased();
			r3Purchased.setOrderNumber(orderOptions.orderCode);
			orderOptions.items.forEach(orderEntry => {
				let formattedValue = orderEntry.value.replace(/\D/g, '');
				// price format just got changed, if it reverts back
				const decimal = formattedValue.length - 2;
				formattedValue = [
					formattedValue.slice(0, decimal),
					'.',
					formattedValue.slice(decimal),
				].join('');

				r3Purchased.addItemIdPriceQuantity(
					orderEntry.sku,
					formattedValue,
					orderEntry.stock,
				);
			});
			window.R3_PURCHASED = r3Purchased;
		}
	}

	parsePersonalOptions() {
		window.R3_PERSONAL = new window.r3_personal();
	}

	addCartEntry(vikingLegacySku) {
		if (!window.R3_ADDTOCART) {
			const r3addtocart = new window.r3_addtocart();
			window.R3_ADDTOCART = r3addtocart;
		}
		window.R3_ADDTOCART.addItemIdToCart(vikingLegacySku);
	}

	addCategoryHintId(categoryId) {
		this.r3Common.addCategoryHintId(categoryId);
	}

	resetData() {
		const rrDataPoints = [
			'R3_HOME',
			'R3_ITEM',
			'R3_SEARCH',
			'R3_CATEGORY',
			'R3_CART',
			'R3_PURCHASED',
			'R3_PERSONAL',
			'R3_ADDTOCART',
		];

		rrDataPoints.forEach(dataId => {
			if (window[dataId] && window[dataId].destroy) {
				window[dataId].destroy();
				delete window[dataId];
			}
		});
		this.resetCommonData();
	}

	resetCommonData() {
		if (window.R3_COMMON) {
			['categoryHintIds', 'itemIds', 'searchTerms', 'placementTypes'].forEach(
				attr => {
					if (Object.prototype.hasOwnProperty.call(window.R3_COMMON, attr)) {
						window.R3_COMMON[attr] = this.defineResetValue(attr);
					}
				},
			);
		}
	}

	defineResetValue(attr) {
		return attr === 'itemIds' ? undefined : '';
	}
}
